export default "__VITE_ASSET__Bznv0suN__"